import React, { useState } from 'react';
import styles from './SymptomsChecker.module.css';
import { Button } from '@mui/material';

const SymptomChecker = () => {
  const [selectedSymptoms, setSelectedSymptoms] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState('');
  const [mealDetails, setMealDetails] = useState('');

  const handleSymptomSelect = (symptom) => {
    if (selectedSymptoms.includes(symptom)) {
      setSelectedSymptoms(selectedSymptoms.filter((s) => s !== symptom));
    } else {
      setSelectedSymptoms([...selectedSymptoms, symptom]);
    }
  };

  const handleMedicalHistoryChange = (e) => {
    setMedicalHistory(e.target.value);
  };

  const handleMealDetailsChange = (e) => {
    setMealDetails(e.target.value);
  };

  // Define your list of common symptoms here
  const commonSymptoms = [
    'Fever',
    'Headache',
    'Cough',
    // Add more symptoms
  ];

  const handleSubmit = () => {
    // Add logic to submit data to your backend or perform processing
  };

  return (
    <div className={styles.container}> {/* Apply the CSS class */}
      <h1>Ayurveda and Homeopathy Symptom Checker</h1>

      <h2>Select Symptoms:</h2>
      {commonSymptoms.map((symptom) => (
        <div key={symptom}>
          <label>
            <input
              type="checkbox"
              checked={selectedSymptoms.includes(symptom)}
              onChange={() => handleSymptomSelect(symptom)}
            />
            {symptom}
          </label>
        </div>
      ))}

      <h2>Medical History:</h2>
      <textarea
        rows="4"
        cols="50"
        value={medicalHistory}
        onChange={handleMedicalHistoryChange}
        className={styles.textarea}
      />

      <h2>Last Meal Details:</h2>
      <textarea
        rows="4"
        cols="50"
        value={mealDetails}
        onChange={handleMealDetailsChange}
        className={styles.textarea}
      />

      <Button type='secondary' onClick={handleSubmit} className={styles.button}>Check Symptom</Button>
    </div>
  );
};

export default SymptomChecker;